import React from 'react';
import style from './PageHeader.module.css';
import TruncateText from '../CompactText/TruncateText';

type PageHeaderProps = {
  title: string;
  extraInfo: string;
  isMobileDevice: boolean;
  url?: string;
  isExtraInfoVisible?: boolean;
};

const PageHeader = ({
  title,
  extraInfo,
  isMobileDevice,
  url = '',
  isExtraInfoVisible = false
}: PageHeaderProps) => {
  return (
    <div className={`${style.pageHeader}`}>
      <div className="makeFlex column appendTop10 appendBottom10">
        <h1 className="font22 blackText latoBlack appendBottom5">{title}</h1>
        {extraInfo && isExtraInfoVisible && (
          <div className="pageExtraInfo font15 appendTop5 ">
            <TruncateText
              text={extraInfo}
              isMobileDevice={isMobileDevice}
              url={url}
              textLength={88}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default PageHeader;
